//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// event-summary
import * as s from "./CardTopLine.styles";
// other components
import { CardTopLineToggle } from "./CardTopLineToggle";

//////////////////
// TYPEs
//////////////////
interface IProps {
  text: string;
  open?: boolean;
  showToggle?: boolean;
  textColor?: string;
}

//////////////////
// COMPONENT
//////////////////
// legacy — DO NOT USE
export class CardTopLineOld extends React.Component<IProps> {
  public render() {
    const { text, open, showToggle, textColor } = this.props;
    const style = { ...s.topLine };
    if (!!textColor) {
      style.color = textColor;
    }
    return (
      <div style={style}>
        {text}
        {showToggle && <CardTopLineToggle open={open} />}
      </div>
    );
  }
}
